import React from "react";
import style from "styled-components";

export const FooterContainer = style.div`
width: 100%;
text-align:center;
position: relative;
bottom: 0;
left: 0;
margin-top:2.0rem;
`;

export const FooterLink = style.a`
text-decoration: none;
 margin-left: 7px;
color: black;
&:hover{
    color:red;
}
`;

export default function index() {
    return (
        <FooterContainer>
            Made by
            <FooterLink href="https://www.linkedin.com/in/leandro-cavalcanti-8a3a0592/">
                Leandro Cavalcanti
            </FooterLink>
        </FooterContainer>
    );
}
